import i18n from '@/lang/i18n'
import { STATUS } from '@/api/utils'

export const ERRORS = {
    UNKNOWN: { title: i18n.t('error.unknown.title'), text: i18n.t('error.unknown.text') },
    AUTH: { title: i18n.t('error.auth.title'), text: i18n.t('error.auth.text') },
    UNAUTHORIZED: { title: i18n.t('error.unauthorized.title'), text: i18n.t('error.unauthorized.text') },
    NOTFOUND: { title: i18n.t('error.notfound.title'), text: i18n.t('error.notfound.text') },
    CONFLICT: { title: i18n.t('error.conflict.title'), text: i18n.t('error.conflict.text') },
}

export const NOTIFICATION_TYPES = {
    info: 'info',
    success: 'success',
    error: 'error',
    warning: 'warning',
}

const generateFieldErrors = (error = {}, duration = 8000) => {
    const { message: title, errors: fields = {} } = error
    // Generate list with all messages
    const errors = Object.values(fields).reduce((acc, msgs) => [...acc, ...msgs.map(msg => msg)], [])
    // Generate item error
    const renderError = e => `<li class="FieldErrorsItem">${e}</li>`
    // Generate list error. The styles of classes are in WNotification component
    const text = `<ul class="FieldErrors">${errors.map(renderError).join('')}</ul>`

    return {
        ...(errors.length ? { title, text } : { text: title }),
        duration,
    }
}

const http = {
    [STATUS.UNAUTHORIZED]: props => ({ type: NOTIFICATION_TYPES.error, ...ERRORS.AUTH, ...props }),
    [STATUS.FORBIDDEN]: props => ({ type: NOTIFICATION_TYPES.error, ...ERRORS.UNAUTHORIZED, ...props }),
    [STATUS.UNPROCESSABLE]: ({ data, ...props }) => ({ type: NOTIFICATION_TYPES.error, ...props, ...generateFieldErrors(data) }),
    [STATUS.BADREQUEST]: ({ data, ...props }) => ({
        type: NOTIFICATION_TYPES.error, ...ERRORS.CONFLICT, ...props, ...generateFieldErrors(data),
    }),
    [STATUS.NOTFOUND]: props => ({ type: NOTIFICATION_TYPES.error, ...ERRORS.NOTFOUND, ...props }),
    [STATUS.CONFLICT]: props => ({ type: NOTIFICATION_TYPES.error, ...ERRORS.CONFLICT, ...props }),
    default: props => ({ type: NOTIFICATION_TYPES.error, ...ERRORS.UNKNOWN, ...props }),
}

export const notification = ({ status, ...props }) => (http[status] || http.default)(props)

export default {
    ERRORS,
    NOTIFICATION_TYPES,
    notification,
}
